import { render, staticRenderFns } from "./OrdersListItem.vue?vue&type=template&id=12cd1713&"
import script from "./OrdersListItem.vue?vue&type=script&lang=js&"
export * from "./OrdersListItem.vue?vue&type=script&lang=js&"
import style0 from "./OrdersListItem.vue?vue&type=style&index=0&id=12cd1713&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports